/** @format */

import { useEffect, useRef, useState } from "react";

import { getDashboard, getTopSellingProduct, getTopSellingSeller, getTopUser, getPopularProduct, getRecenetOrder, getUser, getOrder, getUserChart, getRevenueChart } from "../../store/dashboard/dashboard.action";
import { connect, useDispatch, useSelector } from "react-redux";

// chart
import { Chart as ChartJS, registerables } from "chart.js";
import { Line } from "react-chartjs-2";

import Table from "../../extra/Table";
import Table2 from "../../extra/Table2";
import { useNavigate } from "react-router-dom";
import { DateRangePicker } from "react-date-range";

import DateRangePicker1 from "react-bootstrap-daterangepicker";
import DateRangePicker2 from "react-bootstrap-daterangepicker";
import "bootstrap-daterangepicker/daterangepicker.css";
import { getImageUrl } from "../../../util/getImageUrl";
//Calendar Css
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css";

import dayjs from "dayjs";
import { getDefaultCurrency } from "../../store/currency/currency.action";
import { getAdminEarning } from "../../store/redeem/redeem.action";
import { getCategory } from "../../store/category/category.action";
import { getAllSubcategory } from "../../store/attribute/attribute.action";
import formatImageUrl, { formatAmount } from "../../extra/functions";
import defaultImage from "../../../assets/images/default.jpg";
import { getProfile } from "../../store/admin/admin.action";

const Dashboard = (props) => {
	let label = [];
	let label1 = [];
	let dataUser = [];
	let data = [];
	let dataTotal = [];
	let dataWith = [];
	let dataWithOut = [];
	const { dashboard, product, seller, user, orderData, popularProduct, recentOrders, userCount, userChart, total, withCom, withOut } = useSelector((state) => state.dashboard);

	const { adminTotalEarnings, adminTotalShippingEarnings } = useSelector((state) => state.redeem);

	const { category } = useSelector((state) => state.category);
	const { subcategory } = useSelector((state) => state.attribute);

	useEffect(() => {
		dispatch(getAdminEarning("1", "10", "All", "All"));
		dispatch(getCategory());
		dispatch(getAllSubcategory());
	}, []);

	const [type, setType] = useState("Product");
	const [order, setOrder] = useState([]);

	const [page, setPage] = useState(1);

	const [rowsPerPage, setRowsPerPage] = useState(10);
	const [dateRangerShowType, setDateRangerShowType] = useState({
		toggle: false,
		type: "",
	});
	const dispatch = useDispatch();
	const [date, setDate] = useState([]);
	const [sDate, setsDate] = useState("All");
	const [eDate, seteDate] = useState("All");

	const [date2, setDate2] = useState([]);

	const [sDate3, setSDate3] = useState("All");
	const [eDate3, setEDate3] = useState("All");

	const [sDate2, setsDate2] = useState("All");
	const [eDate2, seteDate2] = useState("All");

	const startDateFormat = (startDate) => {
		return startDate && dayjs(startDate).isValid() ? dayjs(startDate).format("YYYY-MM-DD") : dayjs().subtract(7, "day").format("YYYY-MM-DD");
	};
	const endDateFormat = (endDate) => {
		return endDate && dayjs(endDate).isValid() ? dayjs(endDate).format("YYYY-MM-DD") : dayjs().format("YYYY-MM-DD");
	};

	const startDateData = startDateFormat(sDate);
	const endDateData = endDateFormat(eDate);

	const { defaultCurrency } = useSelector((state) => state.currency);

	const [userChartData, setUserChartData] = useState();

	// chart

	const [startDate, setStartDate] = useState("All");
	const [endDate, setEndDate] = useState("All");

	const [sDate1, setSDate1] = useState("All");
	const [eDate1, setEDate1] = useState("All");

	const startDateFormat1 = (startDate) => {
		return startDate && dayjs(startDate).isValid() ? dayjs(startDate).format("YYYY-MM-DD") : dayjs().subtract(7, "day").format("YYYY-MM-DD");
	};
	const endDateFormat1 = (endDate) => {
		return endDate && dayjs(endDate).isValid() ? dayjs(endDate).format("YYYY-MM-DD") : dayjs().format("YYYY-MM-DD");
	};

	// const startDateData1 = startDateFormat1(sDate1);
	// console.log("startDateData1", startDateData1);

	// const endDateData1 = endDateFormat1(eDate1);
	// console.log("endDateData1", endDateData1);
	const startDateData1 = sDate1 === "All" ? "All" : dayjs(sDate1).format("YYYY-MM-DD");
	console.log("startDateData1", startDateData1);

	const endDateData1 = eDate1 === "All" ? "All" : dayjs(eDate1).format("YYYY-MM-DD");
	console.log("endDateData1", endDateData1);

	const [analyticTotal, setAnalyticTotal] = useState([]);
	const [analyticWith, setAnalyticWith] = useState([]);
	const [analyticWithOut, setAnalyticWithOut] = useState([]);
	const dateRangePickerRef = useRef();
	const dateRangePickerRef1 = useRef();

	useEffect(() => {
		dispatch(getProfile());
	}, []);

	useEffect(() => {
		dispatch(getDefaultCurrency());
	}, [dispatch]);

	useEffect(() => {
		setAnalyticTotal(total);
	}, [total]);

	useEffect(() => {
		setAnalyticWith(withCom);
	}, [withCom]);
	useEffect(() => {
		setAnalyticWithOut(withOut);
	}, [withOut]);

	var dateAnalytic = new Date();
	var firstDay = new Date(dateAnalytic?.getFullYear(), dateAnalytic?.getMonth() - 1, 1);

	const maxDate = new Date();

	const navigate = useNavigate();

	useEffect(() => {
		dispatch(getDashboard());
		dispatch(getTopSellingProduct());
		dispatch(getTopSellingSeller());
		dispatch(getTopUser());
		dispatch(getPopularProduct());
		dispatch(getRecenetOrder());
		dispatch(getOrder(startDate, endDate));
	}, [dispatch, startDate, endDate]);

	useEffect(() => {
		dispatch(getUserChart(startDateData, endDateData));
	}, [dispatch, startDateData, endDateData]);

	useEffect(() => {
		dispatch(getRevenueChart(startDateData1, endDateData1));
	}, [dispatch, startDateData1, endDateData1]);

	useEffect(() => {
		if (sDate3 === "All" && eDate3 === "All") {
			dispatch(getUser(sDate1, eDate1));
		}
	}, [dispatch, sDate3, eDate3]);

	useEffect(() => {
		setOrder(recentOrders);
		// setUserData(userCount);
		// setOrderDate(orderData);
		setUserChartData(userChart);
	}, [recentOrders, userChart]);

	const collapsedDatePicker = (type) => {
		if (type === "dateRangeOne") {
			setDateRangerShowType({
				type: "dateRangeOne",
				toggle: !dateRangerShowType.toggle,
			});
		} else {
			setDateRangerShowType({
				type: "dateRangeTwo",
				toggle: !dateRangerShowType.toggle,
			});
		}
	};

	const handleCloseDateRange = () => {
		setDateRangerShowType({
			type: "",
			toggle: false,
		});
	};
	useEffect(() => {
		const handleClickOutside = (event) => {
			if (dateRangePickerRef.current && !dateRangePickerRef.current.contains(event.target) && dateRangePickerRef1.current && !dateRangePickerRef1.current.contains(event.target)) {
				handleCloseDateRange();
			}
		};

		document.addEventListener("click", handleClickOutside);
		return () => {
			document.removeEventListener("click", handleClickOutside);
		};
	}, []);

	// Display the label name based on the startDatee
	useEffect(() => {
		if (date.length === 0) {
			setDate([
				{
					startDate: new Date(),
					endDate: new Date(),

					key: "selection",
				},
			]);
		}
	}, [date]);

	useEffect(() => {
		if (date2.length === 0) {
			setDate2([
				{
					startDate: new Date(),
					endDate: new Date(),

					key: "selection",
				},
			]);
		}
	}, [date2]);

	const handleOpen = (id) => {
		navigate("/admin/order/orderDetail", {
			state: id,
		});
	};

	// CHART

	if (userChartData?.length > 0) {
		userChartData.map((data_) => {
			const newDate = data_._id;

			var date;
			if (newDate._id) {
				data = dayjs(newDate?._id).format("DD MMM YYYY");
			} else {
				date = dayjs(newDate).format("DD MMM YYYY");
			}

			date?.length > 0 && label1.push(date);

			dataUser.push(data_.count);
		});
	}

	const chartData = {
		labels: label1,

		datasets: [
			{
				type: "line",
				label: "User",
				data: dataUser,
				fill: false,
				backgroundColor: "rgba(229,74,19,0.15)",
				borderColor: "#E54A13",
				lineTension: 0.5,
				pointBorderWidth: 2,
			},
		],
	};

	const handleApply = (event, picker) => {
		picker.element.val(picker.startDate.format("YYYY-MM-DD") + " / " + picker.endDate.format("YYYY-MM-DD"));
		const dayStart = dayjs(picker.startDate).format("YYYY-MM-DD");

		const dayEnd = dayjs(picker.endDate).format("YYYY-MM-DD");

		setsDate(dayStart);
		seteDate(dayEnd);

		dispatch(getUserChart(dayStart, dayEnd));
	};

	//Cancel button function for analytic
	const handleCancel = (event, picker) => {
		picker.element.val("");
		setsDate("All");
		seteDate("All");
		dispatch(getUserChart("All", "All"));
	};

	// revenue chart

	if (analyticTotal?.length > 0 || analyticWith?.length > 0 || analyticWithOut?.length > 0) {
		analyticTotal.map((data_) => {
			const newDate = data_._id;

			var date;
			if (newDate._id) {
				data = dayjs(newDate?._id).format("DD MMM YYYY");
			} else {
				date = dayjs(newDate).format("DD MMM YYYY");
			}

			date?.length > 0 && label.push(date);

			dataTotal.push(data_?.totalCommission);
		});
	}

	if (analyticWith?.length > 0 || analyticWithOut?.length > 0) {
		analyticWith.map((data_, index) => {
			const newDate = data_._id;

			var date;
			if (newDate._id) {
				date = newDate?._id.split("T");
			} else {
				date = newDate.split("T");
			}

			dataWith.push(data_?.totalEarningWithCommission);
		});
	}

	if (analyticWithOut?.length > 0) {
		analyticWithOut.map((data_, index) => {
			const newDate = data_._id;

			var date;
			if (newDate._id) {
				date = newDate?._id.split("T");
			} else {
				date = newDate.split("T");
			}

			dataWithOut.push(data_?.totalEarningWithoutCommission);
		});
	}

	const chartData1 = {
		labels: label,
		datasets: [
			{
				type: "line",
				label: "Total Earning",
				data: dataTotal,
				fill: false,
				backgroundColor: "rgba(229,74,19,0.15)",
				borderColor: "#E54A13",
				lineTension: 0.5,
				pointBorderWidth: 2,
			},
			{
				type: "line",
				label: "Earning With Commission",
				data: dataWith,
				fill: false,
				backgroundColor: "rgba(78, 78, 105, 0.3)",
				borderColor: "#4E4E69",
				lineTension: 0.5,
				pointBorderWidth: 2,
			},
			{
				type: "line",
				label: "Earning WithOut Commission",
				data: dataWithOut,
				fill: false,
				backgroundColor: "rgb(218, 244, 240,0.3)",
				borderColor: "#B9DBFF",
				lineTension: 0.5,
				pointBorderWidth: 2,
			},
		],
	};

	const handleApply1 = (event, picker) => {
		picker.element.val(picker.startDate.format("YYYY-MM-DD") + " / " + picker.endDate.format("YYYY-MM-DD"));
		const dayStart = dayjs(picker.startDate).format("YYYY-MM-DD");

		const dayEnd = dayjs(picker.endDate).format("YYYY-MM-DD");

		setSDate1(dayStart);
		setEDate1(dayEnd);

		dispatch(getRevenueChart(dayStart, dayEnd));
	};

	//Cancel button function for analytic
	const handleCancel1 = (event, picker) => {
		picker.element.val("");
		// setSDate1(sDate1);
		// setEDate1(eDate1);
		// dispatch(getRevenueChart(sDate1, eDate1));
		setSDate1("All");
		setEDate1("All");
		dispatch(getRevenueChart("All", "All"));
	};

	// Order Table Data
	const mapData = [
		{
			Header: "No",
			width: "60px",
			Cell: ({ index }) => <span className='py-4 fw-normal'>{index + 1}</span>,
		},

		{
			Header: "Order Id",
			body: "orderId",
			Cell: ({ row }) => (
				<span
					className='tableBoldFont orderIdText py-4'
					style={{
						cursor: "pointer",
						color: "#e54a13",
					}}
					onClick={() => handleOpen(row._id)}>
					<b className='fw-normal'>{row?.orderId}</b>
				</span>
			),
		},

		{
			Header: "User",
			body: "user",
			Cell: ({ row }) => (
				<div>
					<span className='tableBoldFont py-4'>
						<b className='fw-normal'>
							{row?.userId?.firstName ? row?.userId?.firstName + " " : "Declotr" + " "}
							{row?.userId?.lastName ? row?.userId?.lastName : "User"}
						</b>
					</span>
				</div>
			),
		},
		{
			Header: "PaymentGateway",
			body: "paymentGateway",
			Cell: ({ row }) => <span className='py-4 fw-normal'>{row?.paymentGateway}</span>,
		},
		{
			Header: `Total (${defaultCurrency?.symbol})`,
			body: "totalPrice",
			Cell: ({ row }) => (
				<>
					<span className='py-4 fw-normal'>{formatAmount(row?.subTotal)}</span>
				</>
			),
		},

		// add more columns as needed
	];

	const mapData1 = [
		{
			Header: "No",
			width: "60px",
			Cell: ({ index }) => <span className='fw-normal'>{index + 1}</span>,
		},
		{
			Header: "User",
			body: "firstName",
			Cell: ({ row }) => (
				<div className='d-flex' onClick={() => navigate("/admin/userProfile", { state: row._id })} style={{ cursor: "pointer" }}>
					<div className=''>
						<img
							src={formatImageUrl(row?.image)}
							style={{ borderRadius: "10px" }}
							height={50}
							width={50}
							alt=''
							onError={(e) => {
								e.target.error = null;
								e.target.src = defaultImage;
							}}
						/>
					</div>
					<span className='fw-bold d-flex align-items-center text-start' style={{ paddingLeft: "10px" }}>
						<b className='fw-normal text-capitalize'>{row.firstName + " " + row.lastName}</b>
					</span>
				</div>
			),
		},

		{
			Header: "Location",
			body: "location",
			Cell: ({ row }) => {
				return (
					<>
						<div className=''>
							<span className='fw-normal text-uppercase'>
								<p className='mb-0 text-uppercase fw-normal'>{row?.location}</p>
							</span>
						</div>
					</>
				);
			},
		},
		{
			Header: "Total Order",
			body: "orderCount",
			Cell: ({ row }) => <span className='mb-0 fw-normal'>{row.orderCount ? row.orderCount : 0}</span>,
		},

		// add more columns as needed
	];
	const mapData2 = [
		{
			Header: "No",
			width: "60px",
			Cell: ({ index }) => <span className='fw-normal'>{index + 1}</span>,
		},
		{
			Header: "Seller",
			body: "firstName",
			Cell: ({ row }) => (
				<div className='d-flex' onClick={() => navigate("/admin/sellerProfile", { state: row._id })} style={{ cursor: "pointer" }}>
					<div className='position-relative'>
						<img src={getImageUrl(row?.image) || ""} style={{ borderRadius: "10px" }} height={50} width={50} alt='' />
					</div>
					<span className='d-flex align-items-center text-start fw-normal' style={{ paddingLeft: "30px" }}>
						<b className=' fw-normal'>{row?.firstName + " " + row?.lastName}</b>
					</span>
				</div>
			),
		},

		{
			Header: "Total Product",
			body: "totalProduct",
			Cell: ({ row }) => <span className='count-badge'>{row.totalProduct ? row.totalProduct : 0}</span>,
		},

		{
			Header: "Total Sold Product",
			body: "totalSales",
			Cell: ({ row }) => <span className='mb-0 fw-normal'>{row.totalProductsSold ? row.totalProductsSold : "0"}</span>,
		},

		// add more columns as needed
	];
	const mapData3 = [
		{
			Header: "No",
			width: "60px",
			Cell: ({ index }) => <span className='fw-normal'>{parseInt(index) + 1}</span>,
		},
		{
			Header: "Product",
			body: "images",
			Cell: ({ row }) => (
				<div className='d-flex' onClick={() => navigate("/admin/productDetail", { state: row })} style={{ cursor: "pointer" }}>
					<div className=''>
						<img src={getImageUrl(row?.mainImage)} height={50} width={50} style={{ borderRadius: "10px" }} alt='' />
					</div>
					<span className=' boxCenter ms-3 fw-normal'>{row?.productName}</span>
				</div>
			),
		},

		{
			Header: "Sold",
			Cell: ({ row }) => (
				<span className='tableBoldFont'>
					<b className='fw-normal'>{row?.sold}</b>
				</span>
			),
		},
		{
			Header: "Rating",
			Cell: ({ row }) => (
				<span className='tableBoldFont'>
					<i className='bi bi-star-fill'></i>
					<b className='fw-normal'>{"(" + row?.rating + ")"}</b>
				</span>
			),
		},
	];

	const mapData4 = [
		{
			Header: "No",
			width: "60px",
			Cell: ({ index }) => <span className='fw-normal'>{parseInt(index) + 1}</span>,
		},
		{
			Header: "Product",
			body: "images",
			Cell: ({ row }) => (
				<div className='d-flex' onClick={() => navigate("/admin/productDetail", { state: row })} style={{ cursor: "pointer" }}>
					<div className=''>
						<img src={getImageUrl(row?.mainImage)} height={50} width={50} style={{ borderRadius: "10px" }} alt='' />
					</div>
					<span className='fw-normal boxCenter' style={{ paddingLeft: "30px" }}>
						<b className='fw-normal'>{row?.productName}</b>
					</span>
				</div>
			),
		},

		{
			Header: "Category",
			Cell: ({ row }) => (
				<span className='tableBoldFont'>
					<p className='mb-0 fw-normal'>{row?.categoryName}</p>
				</span>
			),
		},

		{
			Header: "Rating",
			Cell: ({ row }) => (
				<span className='tableBoldFont'>
					<i className='bi bi-star-fill fw-normal'></i>
					<b className='fw-normal'>{"(" + row?.rating + ")"}</b>
				</span>
			),
		},
	];

	const metricCards = [
		{ title: "Total Users", value: sDate3 === "Today" ? userCount?.todayUsers : userCount?.totalUsers, icon: "bi bi-people-fill", link: "/admin/user", accent: "#3b82f6" },
		{ title: "Total Orders", value: orderData?.totalOrders, icon: "bi bi-bag-fill", link: "/admin/order", accent: "#f59e0b" },
		{ title: "Live Sellers", value: dashboard?.totalLiveSeller, icon: "bi bi-broadcast", link: "/admin/liveSeller", accent: "#ef4444" },
		{ title: "Total Products", value: dashboard?.totalProducts, icon: "bi bi-box-seam", link: "/admin/product", accent: "#e54a13" },
		{ title: "Total Categories", value: category?.length, icon: "bi bi-grid-3x3-gap-fill", link: "/admin/category", accent: "#8b5cf6" },
		{ title: "Sub Categories", value: subcategory?.length, icon: "bi bi-list-nested", link: "/admin/category/subCategory", accent: "#10b981" },
		{ title: "Admin Commission", value: adminTotalEarnings != null ? formatAmount(adminTotalEarnings) : 0, icon: null, iconContent: defaultCurrency?.symbol, link: "/admin/wallet", accent: "#f59e0b" },
		{ title: "Shipping Earnings", value: adminTotalShippingEarnings != null ? formatAmount(adminTotalShippingEarnings) : 0, icon: "bi bi-truck", link: "/admin/wallet", accent: "#0ea5e9" },
	];

	const tabItems = [
		{ key: "Product", label: "Top Selling" },
		{ key: "Popular", label: "Most Popular" },
		{ key: "Seller", label: "Top Seller" },
		{ key: "Customer", label: "Top Buyer" },
	];

	return (
		<>
			<div className='mainDashboard'>
				<div className='dashboard'>
					{/* ── Metric Cards ── */}
					<div className='row'>
						{metricCards.map((card, idx) => (
							<div key={idx} className='col-xl-3 col-lg-4 col-md-6 col-12 mb-4' style={{ cursor: "pointer" }}>
								<div className='dash-metric-card' onClick={() => navigate(card.link)}>
									<div className='d-flex justify-content-between align-items-start'>
										<div>
											<p className='dash-metric-label'>{card.title}</p>
											<h2 className='dash-metric-value'>{card.value ?? 0}</h2>
										</div>
										<div className='dash-metric-icon' style={{ background: card.accent }}>
											{card.icon ? <i className={card.icon}></i> : <span>{card.iconContent}</span>}
										</div>
									</div>
									<div className='dash-metric-footer'>
										<span className='dash-metric-link'>
											View Details <i className='bi bi-arrow-right'></i>
										</span>
									</div>
								</div>
							</div>
						))}
					</div>

					{/* ── Tables Row ── */}
					<div className='row'>
						{/* Left: Tabbed Table */}
						<div className='col-xl-6 col-12'>
							<div className='dash-table-card'>
								<div className='dash-table-tabs'>
									{tabItems.map((tab) => (
										<button key={tab.key} className={`dash-tab-btn ${type === tab.key ? "active" : ""}`} onClick={() => setType(tab.key)}>
											{tab.label}
										</button>
									))}
								</div>
								<div className='dash-table-body'>
									<div className='tableMain m-0' style={{ border: "none", boxShadow: "none" }}>
										{type === "Customer" && <Table2 data={user} mapData={mapData1} serverPerPage={rowsPerPage} serverPage={page} type={"server"} />}
										{type === "Seller" && <Table2 data={seller} mapData={mapData2} serverPerPage={rowsPerPage} serverPage={page} type={"server"} />}
										{type === "Product" && <Table2 data={product} mapData={mapData3} serverPerPage={rowsPerPage} serverPage={page} type={"server"} />}
										{type === "Popular" && <Table2 data={popularProduct} mapData={mapData4} serverPerPage={rowsPerPage} serverPage={page} type={"server"} />}
									</div>
								</div>
							</div>
						</div>

						{/* Right: Recent Orders */}
						<div className='col-xl-6 col-12 mt-xl-0 mt-3'>
							<div className='dash-table-card'>
								<div className='dash-table-tabs'>
									<span className='dash-tab-title'>Recent Orders</span>
								</div>
								<div className='dash-table-body'>
									<div className='tableMain m-0' style={{ border: "none", boxShadow: "none" }}>
										<Table2 data={order} mapData={mapData} serverPerPage={rowsPerPage} serverPage={page} type={"server"} />
									</div>
								</div>
							</div>
						</div>
					</div>

					{/* ── Charts Row ── */}
					<div className='row mt-4'>
						<div className='col-xl-6 col-12'>
							<div className='dash-chart-card'>
								<div className='dash-chart-header'>
									<h6 className='dash-chart-title'>User Growth</h6>
									<DateRangePicker1 initialSettings={{ applyButtonClasses: "btn-default", autoUpdateInput: false, locale: { cancelLabel: "Clear" }, maxDate: new Date() }} onApply={handleApply} onCancel={handleCancel}>
										<input type='text' className='dash-date-input' placeholder='Select Date Range' readOnly />
									</DateRangePicker1>
								</div>
								<div className='dash-chart-body'>
									<Line data={chartData} options={{ responsive: true, maintainAspectRatio: false }} />
								</div>
							</div>
						</div>
						<div className='col-xl-6 col-12'>
							<div className='dash-chart-card'>
								<div className='dash-chart-header'>
									<h6 className='dash-chart-title'>Admin Revenue</h6>
									<DateRangePicker2 initialSettings={{ applyButtonClasses: "btn-default", autoUpdateInput: false, locale: { cancelLabel: "Clear" }, maxDate: new Date() }} onApply={handleApply1} onCancel={handleCancel1}>
										<input type='text' className='dash-date-input' placeholder='Select Date Range' readOnly />
									</DateRangePicker2>
								</div>
								<div className='dash-chart-body'>
									<Line data={chartData1} options={{ responsive: true, maintainAspectRatio: false }} />
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};
ChartJS.register(...registerables);

export default connect(null, {
	getDashboard,
	getTopSellingProduct,
	getTopSellingSeller,
	getTopUser,
	getUser,
	getOrder,
	getPopularProduct,
	getRecenetOrder,
	getUserChart,
	getRevenueChart,
})(Dashboard);
